export const LAYOUT_MANAGER_HOME = `/app/home`;
export const LAYOUT_MANAGER_INDEX = "/app/index";

export const LAYOUT_MANAGER_HOME_CALENDAR = "/app/home/calendar";
export const LAYOUT_MANAGER_HOME_DASHBOARD = "/app/home/dashboard";
export const LAYOUT_MANAGER_HOME_EVENT = "/app/home/event";

export const LAYOUT_MANAGER_USER_ROOT = `/app/user`;
export const LAYOUT_MANAGER_USER_SHOW = `/app/user/show`;

export const LAYOUT_MANAGER_CLIENT_ROOT = "/app/manager/client";
export const LAYOUT_MANAGER_CLIENT_LIST = "/app/manager/client/list";
export const LAYOUT_MANAGER_CLIENT_NEW = "/app/manager/client/new";
export const LAYOUT_MANAGER_CLIENT_EDIT = (id) => `/app/manager/client/edit/${id}`;
export const LAYOUT_MANAGER_CLIENT_SHOW = (id) => `/app/manager/client/show/${id}`;
export const LAYOUT_MANAGER_CLIENT_AGREEMENT_SHOW = (id, catlog) =>
    `/app/manager/client/show/${id}/agreement/${catlog}`;

export const LAYOUT_MANAGER_PROJECT_ROOT = "/app/manager/project";
export const LAYOUT_MANAGER_PROJECT_LIST = "/app/manager/project/list";
export const LAYOUT_MANAGER_PROJECT_NEW = "/app/manager/project/new";
export const LAYOUT_MANAGER_PROJECT_EDIT = (id) => `/app/manager/project/edit/${id}`;
export const LAYOUT_MANAGER_PROJECT_SHOW = (id) => `/app/manager/project/show/${id}`;
export const LAYOUT_MANAGER_PROJECT_POS_NEW = (id) => `/app/manager/project/${id}/pos/new`;
export const LAYOUT_MANAGER_PROJECT_POS_EDIT = (id, posId) => `/app/manager/project/${id}/pos/edit/${posId}`;

export const LAYOUT_MANAGER_VENDOR_ROOT = "/app/manager/vendor";
export const LAYOUT_MANAGER_VENDOR_LIST = "/app/manager/vendor/list";
export const LAYOUT_MANAGER_VENDOR_NEW = "/app/manager/vendor/new";
export const LAYOUT_MANAGER_VENDOR_EDIT = (id) => `/app/manager/vendor/edit/${id}`;
export const LAYOUT_MANAGER_VENDOR_SHOW = (id) => `/app/manager/vendor/show/${id}`;

/**
 * JOB module
 */
export const LAYOUT_MANAGER_JOB_ROOT = `/app/manager/job`;
export const LAYOUT_MANAGER_JOB_LIST = `/app/manager/job/list`;
export const LAYOUT_MANAGER_JOB_SHOW = (id) => `/app/manager/job/show/${id}`;
export const LAYOUT_MANAGER_JOB_EDIT = (id) => `/app/manager/job/edit/${id}`;
export const LAYOUT_MANAGER_JOB_NEW = `/app/manager/job/new`;

export const LAYOUT_MANAGER_TASK_RECEIVABLE_SALESFORCE = (id) => `/app/manager/job/task/receivable/${id}`;
export const LAYOUT_MANAGER_TASK_RECEIVABLE_XTM = (id) => `/app/manager/job/task/receivable-xtm/${id}`;

/**
 * QUOTE module
 */
export const LAYOUT_MANAGER_QUOTE_ROOT = `/app/manager/quote`;
export const LAYOUT_MANAGER_QUOTE_LIST = `/app/manager/quote/list`;
export const LAYOUT_MANAGER_QUOTE_SHOW = (id) => `/app/manager/quote/show/${id}`;
export const LAYOUT_MANAGER_QUOTE_EDIT = (id) => `/app/manager/quote/edit/${id}`;
export const LAYOUT_MANAGER_QUOTE_NEW = `/app/manager/quote/new`;

export const LAYOUT_MANAGER_QTASK_RECEIVABLE_SALESFORCE = (id) => `/app/manager/quote/qtask/receivable/${id}`;
export const LAYOUT_MANAGER_QTASK_RECEIVABLE_XTM = (id) => `/app/manager/quote/qtask/receivable-xtm/${id}`;

export const LAYOUT_MANAGER_QA_ROOT = "/app/manager/qa";
export const LAYOUT_MANAGER_QA_LIST = "/app/manager/qa/list";
